import React from 'react';
import styled from 'styled-components';

import { CardWrapper, CardSection, CardToolbar, CardTool, CardIcon } from 'components/Shared/Cards';
import { FlexRow } from 'components/Shared/Scaffolding';
import { GLYPHS } from 'components/Shared/Icon';
import MarkerPreview from 'components/MarkerSettings/MarkerPreviewIcon';

const StyledFlexContent = styled.div`
    flex: 1 1 auto;
    width: 100%;
    min-width: 50%;
`;

const StyledFlexRow = styled(FlexRow)`
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
`;

const Label = styled.strong`
    flex: 0 0 auto;
`;

const Value = styled.span`
    flex: 1 1 auto;
    min-width: 50%;
`;

const MarkerPreviewRow = ({
    marker,
    zoom,
    onHighlightClick,
    onEditClick,
    onDeleteClick,
    onInfoWindowClick,
    styleImageUrl,
}) => {
    const {
        name,
        location: { lat, lng },
        icon,
    } = marker;
    return (
        <CardWrapper>
            <CardSection onClick={() => onEditClick(marker, zoom)}>
                <FlexRow alignCenter inline>
                    <MarkerPreview icon={icon} styleImageUrl={styleImageUrl} />
                    <StyledFlexContent spacing="4px">
                        <StyledFlexRow spacing="4px">
                            <Label>Name:</Label>
                            <Value>{name}</Value>
                        </StyledFlexRow>
                        <FlexRow spacing="4px">
                            <Label>Location:</Label>
                            <Value>
                                {lat}, {lng}
                            </Value>
                        </FlexRow>
                    </StyledFlexContent>
                    <CardIcon primary glyph={GLYPHS.EDIT} />
                </FlexRow>
            </CardSection>
            <CardToolbar>
                <CardTool
                    title="Snap the map to this marker"
                    glyph={GLYPHS.MY_LOCATION}
                    onClick={() => onHighlightClick(marker, zoom)}
                />
                <CardTool
                    title="Add/Edit a popup for this marker"
                    glyph={GLYPHS.INFO_WINDOW}
                    onClick={() => onInfoWindowClick(marker, zoom)}
                />
                <CardTool title="Delete marker" right glyph={GLYPHS.DELETE} onClick={() => onDeleteClick(marker)} />
            </CardToolbar>
        </CardWrapper>
    );
};

export default MarkerPreviewRow;
